import { combineReducers } from "redux";
import createNamedWrapperReducer from "@redux/feature/Markets/Common/Reducers/wrapperReducer";
import MarketMap from "./MarketMap";
import OverviewHolding from "./OverviewHoldingData";
import AlertsOverview from "./AlertsOverviewReducer";
import holdingOverView from "./holdingOverView";
export default combineReducers({
    marketMap: createNamedWrapperReducer(MarketMap, "mapDetails"),
    overviewHoldingData: createNamedWrapperReducer(OverviewHolding, "accOverView"),
    getAlertsOverviewData: createNamedWrapperReducer(AlertsOverview, "alertsOverview"),
    holdingData: createNamedWrapperReducer(holdingOverView, "holdingData"),
});
